export const NAMESPACE = "AddEditColumnModal";
export const FIELD_LEVEL_EVENT = "event";
export const FIELD_LEVEL_GLOBAL = "global";

// TODO not sure how is this going to be handled for the new case,
// should we call api to get actual variants?
export const MOCKED_NEW_FIELD_LANGUAGE_PROP = {
  default: {
    code: "en_US",
    label: "English (US)",
    value: ""
  },
  variants: []
};
export const MOCKED_LANGUAGE_PROP_IN_FIELD = {
  default: {
    code: "en_US",
    label: "English (US)",
    value: ""
  },
  variants: [
    {
      code: "en_CA",
      label: "English (Canada)",
      show: true,
      value: ""
    },
    {
      code: "fr",
      label: "French (Standard)",
      show: false,
      value: ""
    }
  ]
};
